"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";

export function QueryProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  const [queryClient] = React.useState(
    () => {
      const client = new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
      });
      for (const key of ["connections", "groups", "catalog", "monitored-extractions", "templates", "custom-variables", "job-config", "genio-config"]) {
        client.setQueryDefaults([key], { staleTime: 30_000 });
      }
      return client;
    },
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
